interface MediaItem {
  cover: string;
  title: string;
  duration: string;
  tag: string;
  views: string;
}

const mediaItems: MediaItem[] = [
  {
    cover: 'https://readdy.ai/api/search-image?query=Dramatic%20scene%20of%20a%20Chinese%20TV%20studio%20with%20stage%20lights%20and%20equipment%2C%20behind%20the%20scenes%20footage%20style%2C%20warm%20dramatic%20lighting%2C%20cinematic%20composition%2C%20soft%20film%20grain%2C%20mysterious%20atmosphere&width=640&height=360&seq=media-cover-01&orientation=landscape',
    title: '综艺录制现场独家画面还原',
    duration: '04:32',
    tag: '独家视频',
    views: '128万',
  },
  {
    cover: 'https://readdy.ai/api/search-image?query=A%20press%20conference%20scene%20with%20multiple%20microphones%20and%20cameras%2C%20Chinese%20entertainment%20news%20style%2C%20bright%20studio%20lighting%2C%20journalistic%20photography%2C%20clean%20professional%20composition&width=640&height=360&seq=media-cover-02&orientation=landscape',
    title: '当事人独家回应：事件真相全纪录',
    duration: '08:15',
    tag: '深度访谈',
    views: '256万',
  },
  {
    cover: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20social%20media%20feed%20with%20Chinese%20text%2C%20recording%20indicator%20visible%2C%20digital%20screen%20photography%2C%20soft%20ambient%20light%2C%20tech%20lifestyle%20aesthetic&width=640&height=360&seq=media-cover-03&orientation=landscape',
    title: '录音证据完整版首次公开',
    duration: '12:08',
    tag: '实锤证据',
    views: '512万',
  },
  {
    cover: 'https://readdy.ai/api/search-image?query=A%20crowd%20of%20people%20with%20smartphones%20recording%20an%20event%2C%20Chinese%20street%20scene%2C%20dramatic%20ambient%20lighting%2C%20documentary%20photography%20style%2C%20warm%20tones%2C%20realistic%20texture&width=640&height=360&seq=media-cover-04&orientation=landscape',
    title: '现场群众手机拍摄多角度还原',
    duration: '03:45',
    tag: '现场直击',
    views: '89万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            视频爆料
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            一手视频证据，还原事件真相
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
            >
              {/* Cover */}
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                {/* Play overlay */}
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                {/* Duration */}
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-black/60 text-background-50 text-xs">
                  {item.duration}
                </span>
              </div>

              {/* Info */}
              <div className="p-3">
                <h3 className="font-semibold text-foreground-900 text-sm mb-1.5 line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between">
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs bg-primary-100 text-primary-700">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}